import { useState } from 'react';
import styles from './ImagePresentation.module.scss';
import next from '../../Assets/Images/Icons/Other/next.png';
import prev from '../../Assets/Images/Icons/Other/prev.png';

const ImagePresentation = ({ images = [], customStyle }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(null); // when not null, we are animating

    const isAnimating = nextIndex !== null;

    const nextImage = () => {
        if (!images.length || isAnimating) return;
        setNextIndex((currentIndex + 1) % images.length);
    };

    const prevImage = () => {
        if (!images.length || isAnimating) return;
        setNextIndex((currentIndex - 1 + images.length) % images.length);
    };

    const handleAnimationEnd = () => {
        setCurrentIndex(nextIndex);
        setNextIndex(null);
    };

    if (!images.length) return null;

    return (
        <div className={styles.presentationContainer} style={customStyle}>
            <div className={styles.imageWrapper}>
                {/* Base (current) layer */}
                <img
                    src={images[currentIndex]}
                    alt={`Slide ${currentIndex + 1}`}
                    className={styles.image}
                    draggable={false}
                />

                {/* Incoming (next) layer */}
                {nextIndex !== null && (
                    <img
                        key={images[nextIndex]} // force a fresh mount so animation always fires
                        src={images[nextIndex]}
                        alt={`Slide ${nextIndex + 1}`}
                        className={`${styles.image} ${styles.incoming} ${styles.fadeIn}`}
                        onAnimationEnd={handleAnimationEnd}
                        draggable={false}
                    />
                )}

                {images.length > 1 ?
                    <>
                        <div className={styles.arrowLeft} onClick={prevImage}>
                            <img src={prev} alt='prev' />
                        </div>
                        <div className={styles.arrowRight} onClick={nextImage}>
                            <img src={next} alt='next' />
                        </div>
                    </>
                    :
                    null
                }
            </div>
        </div>
    );
};

export default ImagePresentation;
